import gtag_event from './gtag-init';

jQuery(function($){

  $('.open-modal-compare').on('click', function () {
    $('#compare-project-popup').modal('show');
  });

  $('#compare-project-form').on('submit', function () {
    var selected = $('#compare-project-selection').val();

    gtag_event('Comparison action', 'click_bandingkan');
    location.href = selected;
    return false;
  });

});


// WEBPACK FOOTER //
// ./scripts/page-template/page-builder/compare-property.js